import { Circle } from 'styled-system/jsx';
import { FC, ReactNode } from 'react';
import { SystemStyleObject } from 'styled-system/types';

type PropsType = {
  backgroundColor: SystemStyleObject['backgroundColor'];
  width: SystemStyleObject['width'];
  height: SystemStyleObject['height'];
  borderColor?: SystemStyleObject['borderColor'];
  children: ReactNode;
};

const CustomIcon: FC<PropsType> = ({
  children,
  width,
  height,
  backgroundColor,
  borderColor,
}) => {
  return (
    <Circle
      backgroundColor={backgroundColor}
      height={height}
      width={width}
      borderColor={borderColor}
      border={borderColor ? '1px solid' : 'none'}
    >
      {children}
    </Circle>
  );
};

export default CustomIcon;
